import { Input, Modal, Table } from "antd"
import { useState } from "react"
import VSpace from "../../common/VSpace"
import { QboEmployee } from "./crewMemberApi"
import { useQboEmployees } from "./crewMemberQueries"

export type Props = {
  open: boolean
  onSubmit: (qboId?: string, qboDisplayName?: string) => void
  onCancel: () => void
}

const LinkCrewMemberModal = ({ open, onSubmit, onCancel }: Props) => {
  const qboEmployees = useQboEmployees()
  const [search, setSearch] = useState('')
  const [selectedEmployee, setSelectedEmployee] = useState<QboEmployee | undefined>()

  const employees = qboEmployees.data?.filter(employee => employee.displayName.toLowerCase().includes(search.toLowerCase())) ?? []

  return <Modal
    open={open}
    title="Link Crew Member to QuickBooks Online"
    onOk={() => onSubmit(selectedEmployee?.id, selectedEmployee?.displayName)}
    onCancel={onCancel}
  >
    <VSpace>
      <Input.Search value={search} onChange={e => setSearch(e.target.value)} />
      <Table
        dataSource={employees}
        rowKey="id"
        scroll={{ y: 400 }}
        style={{ height: 400 }}
        pagination={false}
        columns={[
          {
            dataIndex: 'displayName',
          }
        ]}
        showHeader={false}
        rowSelection={{
          selectedRowKeys: selectedEmployee ? [selectedEmployee.id] : [],
          type: 'radio',
          onChange: (keys) => {
            const employee = employees.find(employee => keys.includes(employee.id))
            setSelectedEmployee(employee)
          },
          renderCell: () => '',
          columnWidth: 0,
        }}
        onRow={(record) => ({
          onClick: () => setSelectedEmployee(record)
        })}
      />
    </VSpace>
  </Modal>
}

export default LinkCrewMemberModal
